// Rule string format shared with the backend: "[ok|fail] [re:|has:]pattern".

export const parseRule = (line) => {
    let s = (line || '').trim();
    let verdict = 'ok';
    const l1 = s.toLowerCase();
    if (l1.startsWith('fail ')) { verdict = 'fail'; s = s.slice(5).trim(); }
    else if (l1.startsWith('ok ')) { verdict = 'ok'; s = s.slice(3).trim(); }

    let type = 'has';
    const l2 = s.toLowerCase();
    if (l2.startsWith('re:')) { type = 're'; s = s.slice(3); }
    else if (l2.startsWith('has:')) { type = 'has'; s = s.slice(4); }

    return { verdict, type, pattern: s };
};

export const parseRules = (lines) => (lines || []).map(parseRule);

const serializeRule = (item) => {
    const pattern = (item?.pattern || '').trim();
    if (!pattern) return null;
    const verdict = item.verdict === 'fail' ? 'fail' : 'ok';
    const type = item.type === 'has' ? 'has' : 're';
    return `${verdict} ${type}:${pattern}`;
};

export const serializeRules = (items) => (items || []).map(serializeRule).filter(Boolean);
